import { render, staticRenderFns } from "./WinesEdit.vue?vue&type=template&id=63530982"
import script from "./WinesEdit.vue?vue&type=script&lang=js"
export * from "./WinesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports